module.exports = __webpack_public_path__ + "img/FAQs-pana-pink.d637f842.png";